/**
 * @generated SignedSource<<bb43358d3cee4c52378213c6cb63dddc>>
 * @relayHash e52c4569652a937ea942ab0580bf78a8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a64cdff4e184a264e0c827645083003aa60c4c3da6343b8dcb2e5da301986b7f

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type mainGroupByDropdownWithSearchQuery$variables = {
  nodeId: string;
};
export type mainGroupByDropdownWithSearchQuery$data = {
  readonly node: {
    readonly __typename: "JiraGroupedListView";
    readonly " $fragmentSpreads": FragmentRefs<"main_issueTableGroupByDropdown_GroupByDropdownWithSearch">;
  } | {
    readonly __typename: "JiraListView";
    readonly " $fragmentSpreads": FragmentRefs<"main_issueTableGroupByDropdown_GroupByDropdownWithSearch">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type mainGroupByDropdownWithSearchQuery = {
  response: mainGroupByDropdownWithSearchQuery$data;
  variables: mainGroupByDropdownWithSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nodeId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "nodeId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = [
  {
    "kind": "FragmentSpread",
    "name": "main_issueTableGroupByDropdown_GroupByDropdownWithSearch"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "concreteType": "JiraIssueSearchViewConfigSettings",
        "kind": "LinkedField",
        "name": "viewSettings",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraSpreadsheetGroupByConfig",
            "kind": "LinkedField",
            "name": "groupByConfig",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                  }
                ],
                "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                "kind": "LinkedField",
                "name": "availableGroupByFieldOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraField",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fieldId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "typeKey"
                          },
                          (v4/*: any*/),
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__id"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "availableGroupByFieldOptions(first:10)"
              }
            ]
          }
        ]
      }
    ],
    "type": "JiraSpreadsheetView",
    "abstractKey": "__isJiraSpreadsheetView"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "mainGroupByDropdownWithSearchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v3/*: any*/),
            "type": "JiraGroupedListView"
          },
          {
            "kind": "InlineFragment",
            "selections": (v3/*: any*/),
            "type": "JiraListView"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mainGroupByDropdownWithSearchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v5/*: any*/),
            "type": "JiraGroupedListView"
          },
          {
            "kind": "InlineFragment",
            "selections": (v5/*: any*/),
            "type": "JiraListView"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a64cdff4e184a264e0c827645083003aa60c4c3da6343b8dcb2e5da301986b7f",
    "metadata": {},
    "name": "mainGroupByDropdownWithSearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "72bd98d33da4fadab310edafdc71d815";

export default node;
